import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Text } from 'react-native';

export const ReadonlyQuotationFormSubjectPanelHeader = memo(
  ({ index, title }: { index: number; title: string }) => {
    const { rpx } = useResponsiveContext();

    return (
      <StackLayout direction="row" alignItems="center" flex={1} gap={rpx(8)}>
        <StackLayout direction="row" alignItems="center">
          <Text
            css={`
              font-size: ${rpx(28)}px;
              font-weight: bold;
              font-style: italic;
              color: #0f4884;
            `}
          >{`${index + 1}. `}</Text>
          <Typography.Title level={3} size={rpx(23)} medium color="#0f4884">
            {title}
          </Typography.Title>
        </StackLayout>
      </StackLayout>
    );
  },
);
